// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore"; 
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDO1JD_FHi-LuFu2l70d26sjAwsenu9XP4",
  authDomain: "projectpulse-256c5.firebaseapp.com",
  databaseURL:
    "https://projectpulse-256c5-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "projectpulse-256c5",
  storageBucket: "projectpulse-256c5.appspot.com",
  messagingSenderId: "777229606520",
  appId: "1:777229606520:web:b6ca4dc9ac6d2e1a7e578d",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Realtime Database

export const auth = getAuth(app); // Firebase Authentication
export const googleProvider = new GoogleAuthProvider(); // Google Auth Provider
export const db = getDatabase(app); // Firebase Realtime Database
export const firestore = getFirestore(app);